import { render, staticRenderFns } from "./AuthoriseSubletOld.vue?vue&type=template&id=8c74c150"
import script from "./AuthoriseSubletOld.vue?vue&type=script&lang=js"
export * from "./AuthoriseSubletOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c74c150')) {
      api.createRecord('8c74c150', component.options)
    } else {
      api.reload('8c74c150', component.options)
    }
    module.hot.accept("./AuthoriseSubletOld.vue?vue&type=template&id=8c74c150", function () {
      api.rerender('8c74c150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/AuthoriseSubletOld.vue"
export default component.exports